import { firestore, functions } from 'firebase/app';

export default {
  _ref() {
    return firestore().collection('bank-slip');
  },

  async processPayment(data) {
    console.debug('payment request', data);
    const processPaymentFunction = functions().httpsCallable(
      'processPaymentCall',
    );

    try {
      const response = await processPaymentFunction(data);
      console.debug('payment response', response);
      if (this.hasError(response)) {
        const message = this.handleErrorMessage(response);
        console.warn('payment error message', message);
        throw new Error(message);
      }
      return response.data;
    } catch (error) {
      console.log('payment error', error);
      throw error;
    }
  },

  hasError(response) {
    return (
      (response.data && response.data.error !== undefined) ||
      response.error !== undefined
    );
  },

  handleErrorMessage(response) {
    const error = response.error ?? response.data ? response.data.error : {};
    if (error.code === '019') {
      return 'O CPF informado é inválido. Por favor, forneça um CPF válido';
    } else if (error.message && error.code) {
      return error.message + ' (' + error.code + ')';
    } else if (error.message) {
      return error.message;
    } else {
      return 'Ocorreu um erro durante o pagamento, tente novamente.';
    }
  },

  async createSlip(slip) {
    await this._ref().add(slip);
  },
};
